export const setPasswordPersistStateKeys = [
    'set-password-validate-result',
    'set-password-current-step',
    'set-password-user-data',
    'set-password-email',
    'set-password-source',
];